import { initAppOnReady } from '../utils/appUtils';
import renderIframeApp from '../iframe/renderIframeApp';
initAppOnReady(renderIframeApp);
